import { WebPlugin } from '@capacitor/core';
import { WebStorageAdapter } from './definitions';
import { sessionCookie } from './sessionCookie';
export class SecureStoragePluginWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.PREFIX = 'cap_sec_';
        this.STORAGE_ADAPTER_KEY = 'cap_sec_adapter';
        this.addPrefix = (key) => this.PREFIX + key;
    }
    getCurrentStorageAdapter() {
        const adapter = localStorage.getItem(this.STORAGE_ADAPTER_KEY);
        switch (adapter) {
            case WebStorageAdapter.SessionStorage:
                return sessionStorage;
            case WebStorageAdapter.SessionCookie:
                return sessionCookie;
            default:
                return localStorage;
        }
    }
    async setStorageAdapter(options) {
        localStorage.setItem(this.STORAGE_ADAPTER_KEY, options.web.adapter);
        return {
            value: true,
        };
    }
    async getStorageAdapter() {
        const adapter = (localStorage.getItem(this.STORAGE_ADAPTER_KEY) ||
            WebStorageAdapter.LocalStorage);
        return {
            adapter,
        };
    }
    get(options) {
        const storage = this.getCurrentStorageAdapter();
        const item = storage.getItem(this.addPrefix(options.key));
        if (item !== null) {
            return Promise.resolve({
                value: atob(item),
            });
        }
        else {
            return Promise.reject('Item with given key does not exist');
        }
    }
    getAccessibility( /*_options: { key: string }*/) {
        // Always rejects on web
        return Promise.reject('not implemented on web');
    }
    set(options) {
        const storage = this.getCurrentStorageAdapter();
        storage.setItem(this.addPrefix(options.key), btoa(options.value));
        return Promise.resolve({ value: true });
    }
    remove(options) {
        const storage = this.getCurrentStorageAdapter();
        storage.removeItem(this.addPrefix(options.key));
        return Promise.resolve({ value: true });
    }
    clear() {
        const storage = this.getCurrentStorageAdapter();
        for (const key in storage) {
            if (key.indexOf(this.PREFIX) === 0) {
                storage.removeItem(key);
            }
        }
        // remove eventually set storageAdapter key
        localStorage.removeItem(this.STORAGE_ADAPTER_KEY);
        return Promise.resolve({ value: true });
    }
    keys() {
        const storage = this.getCurrentStorageAdapter();
        const keys = Object.keys(storage).filter((k) => k.indexOf(this.PREFIX) === 0);
        return Promise.resolve({ value: keys });
    }
    getPlatform() {
        return Promise.resolve({ value: 'web' });
    }
}
const SecureStoragePlugin = new SecureStoragePluginWeb();
export { SecureStoragePlugin };
//# sourceMappingURL=web.js.map